import CachedRoundedIcon from '@mui/icons-material/CachedRounded';
import { Box, Button, Typography } from '@mui/material';
import { FC } from 'react';
import { DOAIconComp } from '../../components/DOAIconComp';
import { MainContainer } from '../../components/MainContainerComp';
import { NotEleigibleMessage } from './components/NotEligibleMessage';
import { ShiftCard } from './components/ShiftCard';
import { IDRPluginAvailabilityData, IShift } from './DRPluginAvailabilityData';
import { containerStyle, noShiftsTextStyle } from './styled';

interface IDRPluginAvailabilityProps {
  shifts: IShift[],
  onRefresh: () => void,
  onSelectShift: (e: React.ChangeEvent<HTMLInputElement>) => void,
  onSubmit: () => void,
  hasChanges: boolean,
  data: IDRPluginAvailabilityData,
}

export const DRPluginAvailability: FC<IDRPluginAvailabilityProps> = ({
  onRefresh,
  onSelectShift,
  onSubmit,
  shifts,
  hasChanges,
  data
}) => {
  return (
    <MainContainer hasGreyBg>
      <DOAIconComp />
      <Typography
        component={'div'}
        variant='container'
        data-automation="data-container"
        sx={{ mt: 2 }}
      >
        {
          !shifts || !shifts.length ? (
            <>
              {
                data.messages.length && data.messages.find(m => m.messageSeverity === 'E') ? <NotEleigibleMessage messages={data.messages} /> :
                  <Box sx={{ textAlign: 'center', pt: 8, pb: 8 }}>
                    <Typography sx={noShiftsTextStyle}>There are no Shifts available currently.</Typography>
                    <Typography sx={noShiftsTextStyle}>
                      Please try again later or press the [Refresh] button below to see if any are available now.
                    </Typography>
                    <Button variant="contained" onClick={onRefresh}>
                      Refresh <CachedRoundedIcon />
                    </Button>
                  </Box>
              }
            </>
          ) : (
            <Box sx={containerStyle}>
              {
                shifts.map(s => (
                  <ShiftCard
                    despatchId={s.despatchId}
                    otherTimeNumber={s.otherTimeNumber}
                    status={s.status}
                    isAvailable={data?.shifts && !!data.shifts.find(os =>
                      os.despatchId === s.despatchId)?.isSelected}
                    key={s.despatchId}
                    checked={!!s.isSelected}
                    description={s.despatchDescription}
                    onCheck={onSelectShift}
                  />
                )
                )
              }
              <Box sx={{ textAlign: 'center' }}>
                <Button
                  sx={{ mt: 1, mb: 1 }}
                  disabled={!hasChanges}
                  variant="contained"
                  onClick={onSubmit}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          )
        }
      </Typography>
    </MainContainer>
  )
}